import React from 'react'
import { connect } from 'react-redux'
import EcommerceProductActions from '../../Redux/EcommerceProductRedux'
import moment from 'moment'

class AddEcommerceStock extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      ecommerceProduct: {
        qty: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchViewEcommerceProduct()
  }

  _addEcommerceProductStock = (event) => {
    event.preventDefault()
    let form = {...this.state.ecommerceProduct}
    let data = {
      inventoryID: this.props.inventoryID,
      ecommerceProductID: this.props.ecommerceProductID,
      form
    }
    this.props.createEcommerceProductStock(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  _inputChange = (event, field) => {
    let ecommerceProduct = {...this.state.ecommerceProduct}
    let value = event.target.value
    ecommerceProduct[field] = value
    this.setState({ ecommerceProduct })
  }

  _fetchViewEcommerceProduct = () => {
    let data = {
      inventoryID: this.props.inventoryID,
      ecommerceProductID: this.props.ecommerceProductID
    }
    this.props.viewEcommerceProduct(data)
  }

  render () {
    const { data_view } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Add Stock of {this.props.inventoryName}</h4>
        </div>
        <form onSubmit={(event) => this._addEcommerceProductStock(event)}>
          <div className='form=group row'>
            <div className='col-3'>
              <label className='control-label'>Add Stock</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                min='1'
                className='form-control'
                value={this.state.ecommerceProduct.qty}
                placeholder='Stock quantity'
                onChange={(event) => this._inputChange(event, 'qty')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 mt-3 mb-3 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
        <table className='table table-hover table-striped'>
          <thead>
            <tr>
              <th>Created At</th>
              <th>QTY</th>
            </tr>
          </thead>
          <tbody>
            {
              data_view.inventory_item_stock &&
              data_view.inventory_item_stock.map((item, i) => (
                <tr key={i}>
                  <td>{ moment(item.created_at).format(this.dateformat) }</td>
                  <td>{item.qty}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  data_view: state.ecommerceProduct.data_view
})

const dispatchToProps = (dispatch) => ({
  viewEcommerceProduct: (data) => dispatch(EcommerceProductActions.viewEcommerceProductRequest(data)),
  createEcommerceProductStock: (data) => dispatch(EcommerceProductActions.createEcommerceProductStockRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AddEcommerceStock)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/AddEcommerceStock.js